import * as powerBIStore from './store'

export function powerBiModule({ store }) {
  store.registerModule('power-bi', { ...powerBIStore, namespaced: true })
}
